import axios from 'axios';
import { useAuthStore } from '@/stores/auth.store';
import { normalizeError } from './api-error';

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      // Only redirect when an authenticated session expires, not on a failed login attempt
      const hasToken = !!useAuthStore.getState().accessToken;
      if (hasToken) {
        useAuthStore.getState().logout();
        window.location.href = '/login';
      }
    }
    return Promise.reject(normalizeError(error));
  },
);

export default apiClient;
